export const getResourceI18nNamespace = (resource: string) => {
  return resource + "-resource";
};
